import styles from './Heading.module.css';
import type { HeadingProps } from './Heading.types';

const Heading = ({ children, level, variant, isResponsive = true, ...props }: HeadingProps) => {
  const HeadingElement = level;
  const headingStyles = isResponsive ? styles[variant] : `${styles[variant]} ${styles['non-responsive']}`;

  return (
    <HeadingElement data-test-id="Heading" className={headingStyles} {...props}>
      {children}
    </HeadingElement>
  );
};

export { Heading };
